import { CHECK_REDEMPTION_CODE_VALIDITY_REQUEST, CHECK_REDEMPTION_CODE_VALIDITY_SUCCESS, CHECK_REDEMPTION_CODE_VALIDITY_ERROR, } from '../types';
const checkRedemptionCodeValidityRequest = (code, email) => ({
    type: CHECK_REDEMPTION_CODE_VALIDITY_REQUEST,
    payload: { code, email },
});
const checkRedemptionCodeValidityError = (error, code, email) => ({
    type: CHECK_REDEMPTION_CODE_VALIDITY_ERROR,
    payload: { code, email },
    error,
});
const checkRedemptionCodeValiditySuccess = (code, email, order) => ({
    type: CHECK_REDEMPTION_CODE_VALIDITY_SUCCESS,
    payload: { code, email },
    order,
});
export const checkRedemptionCodeValidity = (code, email) => async (dispatch, _getState, { chord }) => {
    dispatch(checkRedemptionCodeValidityRequest(code, email));
    try {
        const order = await chord.oms.checkRedemptionCodeValidity(code, email);
        dispatch(checkRedemptionCodeValiditySuccess(code, email, order));
        return order;
    }
    catch (e) {
        dispatch(checkRedemptionCodeValidityError(e, code, email));
        throw e;
    }
};
